<cxone-slide-toggle toggleId="{{toggleId}}" name="active-cell" slideOnColor="rgb(0, 124, 190,1)"
    styleClass="medium-toggle" [(ngModel)]="params.node.data.isActive"
    (clicked)="onActiveChanged($event)" [disabled]="isPreview"></cxone-slide-toggle>